module.exports = __webpack_public_path__ + "static/media/Custom.4efdfa6c.jpg";